import { createGetEndpoint } from '@sonar-software/sonar-http';
import { ReferenceCountsWithNames } from '@types';

export type GetSalesforceRefCountsByEntityRequest = { names: Array<string>; };
export type GetSalesforceRefCountsByEntityResponse = Record<string, ReferenceCountsWithNames>;

export const getSalesforceRefCountsByEntity =
	createGetEndpoint<GetSalesforceRefCountsByEntityRequest, GetSalesforceRefCountsByEntityResponse>(
		(request) => {
			const params = new URLSearchParams(request.names.map((n) => [ 'names', n ]));

			return `/api/v3/salesforce/ref-counts/by-entity?${params}`;
		}
	);
